export const sentencia = {
	nombre: "Sentencia",
	dia: "Miércoles Santo",
	nombrecompleto:
		"Venerable, Mercedaria y Lasaliana Cofradía de Penitencia de Nuestro Padre Jesús de la Sentencia y Nuestra Señora del Buen Fin (Vulgo de los estudiantes)",
	sede: "Parroquia de Ntra. Sra. de la Merced",
	pasos: 2,
	distancia: [936, 1620],
	penitentes: 350,
	cargadores: 122,
	web: "http://www.diariodecadiz.es/semana_santa/Sentencia_0_1229277820.html",

	ida: [
		{ lng: -6.2913465, lat: 36.5285417 },
		{ lng: -6.2912983, lat: 36.5286613 },
		{ lng: -6.2912875, lat: 36.5286882 },
		{ lng: -6.2915276, lat: 36.5288262 },
		{ lng: -6.2921163, lat: 36.5290245 },
		{ lng: -6.2921941, lat: 36.5290439 },
		{ lng: -6.292166, lat: 36.5291484 },
		{ lng: -6.2925737, lat: 36.5294027 },
		{ lng: -6.292516, lat: 36.5295719 },
		{ lng: -6.2927909, lat: 36.5297648 },
		{ lng: -6.2919527, lat: 36.530461 },
		{ lng: -6.2926535, lat: 36.5312519 },
		{ lng: -6.2929143, lat: 36.5310903 },
		{ lng: -6.2922028, lat: 36.5302864 },
		{ lng: -6.292811, lat: 36.5297788 },
		{ lng: -6.2929069, lat: 36.5298074 },
		{ lng: -6.2930766, lat: 36.5298047 },
		{ lng: -6.2933086, lat: 36.5297325 },
		{ lng: -6.2936298, lat: 36.5297023 },
		{ lng: -6.2945397, lat: 36.5296366 },
		{ lng: -6.2946142, lat: 36.5295574 },
		{ lng: -6.2950963, lat: 36.5296323 },
		// CATEDRAL
		{ lng: -6.29535, lat: 36.52899 }
	],
	vuelta: [
		// CATEDRAL
		{ lng: -6.29535, lat: 36.52899 },
		{ lng: -6.2957239, lat: 36.5290794 },
		{ lng: -6.2954047, lat: 36.5297433 },
		{ lng: -6.2957132, lat: 36.5299502 },
		{ lng: -6.2952787, lat: 36.5303597 },
		{ lng: -6.2950131, lat: 36.5308338 },
		{ lng: -6.2949246, lat: 36.5308446 },
		{ lng: -6.2949327, lat: 36.5314567 },
		{ lng: -6.2963824, lat: 36.531766 },
		{ lng: -6.2967995, lat: 36.5325375 },
		{ lng: -6.296426, lat: 36.53294 },
		{ lng: -6.2962684, lat: 36.5332369 },
		{ lng: -6.2963274, lat: 36.5332972 },
		{ lng: -6.2962724, lat: 36.5339309 },
		{ lng: -6.2954812, lat: 36.5340192 },
		{ lng: -6.2921941, lat: 36.5302163 },
		{ lng: -6.2927339, lat: 36.5297718 },
		{ lng: -6.2924746, lat: 36.529589 },
		{ lng: -6.2925317, lat: 36.5294192 },
		{ lng: -6.2921296, lat: 36.5291593 },
		{ lng: -6.2921514, lat: 36.5290679 },
		{ lng: -6.2915015, lat: 36.5288528 },
		{ lng: -6.291245, lat: 36.5286967 },
		{ lng: -6.2913076, lat: 36.5285342 }
	],
	markers: [
		{
			name: "Salida",
			hora: "2018-03-28T17:10",
			latlng: [36.52852, -6.29133]
		},
		{
			name: "Nueva",
			hora: "2018-03-28T18:40",
			latlng: [36.53062, -6.29249]
		},
		{
			name: "Catedral",
			hora: "2018-03-28T19:40",
			latlng: [36.52899, -6.29535]
		},
		{
			name: "Candelaria",
			hora: "2018-03-28T20:40",
			latlng: [36.53106, -6.295]
		},
		{
			name: "Palillero",
			hora: "2018-03-28T21:15",
			latlng: [36.53196, -6.2965]
		},
		{
			name: "Valverde Barrié",
			hora: "2018-03-28T21:30",
			latlng: [36.53254, -6.29679]
		}
	],
	itinerario: [
		[
			"Merced",
			"Plaza de las Canastas",
			"Jesús de la Sentencia",
			"San Juan de Dios",
			"Plaza de San Juan de Dios",
			"Avda. 4 de Diciembre de 1977",
			"Cristóbal Colon",
			"Nueva"
		],
		[
			"Plaza San Juan de Dios",
			"Pelota",
			"Plaza Pio XII",
			"Estación de Penitencia en la S.I.C."
		],
		[
			"Arquitecto Acero",
			"Plaza de Pío XII",
			"Compañía",
			"Santiago",
			"Plaza Candelaria"
		],
		["Montañes", "Palillero"],
		["Novena", "Valverde"],
		[
			"Beato Diego de Cadiz",
			"San Francisco",
			"Plaza San Agustín",
			"San Francisco",
			"Nueva",
			"Plaza de San Juan de Dios",
			"San Juan de Dios",
			"Jesús de la Sentencia",
			"Plaza de las Canastas",
			"Merced"
		]
	],
	mapConfig: {
		center: [36.5311, -6.29721],
		zoom: 17
	}
};



// WEBPACK FOOTER //
// ./src/data/procesiones/sentencia.js